__turbopack_export_value__({
  "button": "LoginScreen-module__46-dwq__button",
  "error": "LoginScreen-module__46-dwq__error",
  "input": "LoginScreen-module__46-dwq__input",
  "loginContainer": "LoginScreen-module__46-dwq__loginContainer",
});
